export const getStyles = (isMobile: boolean) => {
  return {
    centered: {
      alignItems: 'center',
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 2,
      paddingTop: '32px',
      width: '100%',
    },

    main: {
      alignContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      width: isMobile ? '470px' : '766px',
    },

    paper: {
      padding: '24px',
      width: '100%',
      mb: '18px',
    },
  }
}
